const rewards_pt = require('./rewards.json')
export default rewards_pt